var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"user-info__summary"},[_c('p',{domProps:{"innerHTML":_vm._s(_vm.userInfoSummary)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }